import { FailedPrefetchRequest } from 'common/query-policy'
import { sendAsyncEventData, serializeError } from 'common/helpers'
import { Routes } from 'common/constants'

interface HomePrefetchEventData {
  prefetchKey: string
  failedRequests: FailedPrefetchRequest[]
  orchestrationError?: string
}

const sendHomePrefetchEventData = async (eventData: HomePrefetchEventData) => {
  await sendAsyncEventData({
    flow: 'home_prefetch',
    step: 'home_prefetch',
    screen_name: Routes.HOME,
    eventData,
  })
}

const sendHomePrefetchOrchestrationError = async (
  prefetchKey: string,
  error: unknown,
  failedRequests: FailedPrefetchRequest[] = [],
) => {
  await sendHomePrefetchEventData({
    prefetchKey,
    failedRequests,
    orchestrationError: serializeError(error),
  })
}

export type { HomePrefetchEventData }
export { sendHomePrefetchEventData, sendHomePrefetchOrchestrationError }
